import request from '@/api/request'

export function fetchList (base, id, query) {
  return request({
    url: '/' + base + '/' + id + '/editlog',
    method: 'get',
    params: query
  })
}

export function fetchOne (id) {
  return request({
    url: '/editlog/' + id,
    method: 'get'
  })
}

export function fetchBaseOne (base, id) {
  return request({
    url: '/' + base + '/editlog/' + id,
    method: 'get'
  })
}
